import {header} from "./elements.js";
import {getElement} from "./helpers.js";


export  default function scrollToAnchor() {
    const links = document.querySelectorAll(".scroll-to");
    links.forEach((link) => {

        link.addEventListener("click", function (event) {

            event.preventDefault();
            const blockID = link.getAttribute("href");

            // if (
            //     document.querySelector(".burger") &&
            //     document.querySelector(".burger").classList.contains("active")
            // ) {
            //     document.querySelector(".burger").classList.toggle("active");
            //     headerNav.classList.toggle("active");
            //     document.body.classList.toggle("active");
            // }



            window.scrollTo({
                top: document.querySelector(`${blockID}`).offsetTop -  header.offsetHeight - 10,
                behavior: "smooth",
            });
            if (document.querySelector('.page__product-item')){
                getElement(blockID).click()
                console.dir(getElement(blockID))
            }

        });
    });
};
